<template>
  <div class="card width-535">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('exportBalanceTiers.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="columns">
        <b-field class="column is-6 obligatoire"
          :label="$t('exportBalanceTiers.dateDebut')">
          <b-datepicker
            show-week-number
            nearby-selectable-month-days
            icon="calendar-today"
            v-model="dateDebut"
            :max-date="dateFin"
            :editable="true">
          </b-datepicker>
        </b-field>
        <b-field class="column is-6 obligatoire"
          :label="$t('exportBalanceTiers.dateFin')">
          <b-datepicker
            show-week-number
            nearby-selectable-month-days
            icon="calendar-today"
            v-model="dateFin"
            :min-date="dateDebut"
            :editable="true">
          </b-datepicker>
        </b-field>
      </div>
    </div>
    <div class="has-text-centered mgt-20px">
      <button
        class="button btn-modal-annuler is-cancel has-text-centered button-modal"
        @click="$parent.close()">
        {{ $t('general.button.cancel') }}
      </button>
      <b-tooltip :active="!dateDebut || !dateFin"
        :label="$t('exportBalanceTiers.errorDates')">
        <button
          class="button is-addOrEdit has-text-centered button-modal"
          :disabled="!dateDebut || !dateFin"
          @click="exportToExcel">
          {{ $t('general.button.export') }}
        </button>
      </b-tooltip>
    </div>
    <a ref="lienDownloadExportExcel"></a>
  </div>
</template>

<script>
import { EXPORT_EXCEL_BALANCE } from '@/configuration/tiers/tiersConf';
import exportExcel from '@/api/exportExcel';
import formatDate from '@/services/general/formatIsoDate';
import messageErreur from '@/services/general/messageErreur';

export default {
  props: {
    queryTiers: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dateDebut: null,
      dateFin: null,
    };
  },
  methods: {
    async exportToExcel() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await exportExcel({
          typeDonnee: EXPORT_EXCEL_BALANCE,
          typeExport: null,
          filtres: this.queryTiers,
          parametresAdditionnels: {
            dateDebut: formatDate(this.dateDebut),
            dateFin: formatDate(this.dateFin),
          },
        });
        const link = this.$refs.lienDownloadExportExcel;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
        this.$emit('close');
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('general.messages.error.excelError'));
        loadingComponent.close();
        throw e;
      }
    },
  },
};
</script>

<style>

</style>
